export default __webpack_public_path__ + "images/7e41d8592eb91015152a089177445ba8-amex@2x.png";